import { MenuItem, MenuList } from '@mui/material';
import { useId } from 'react';

import { type UniversalDrawerFieldConfig } from '../../types';

type FiltersDrawerAddFieldListProps = {
  readonly addableFieldConfigs: readonly UniversalDrawerFieldConfig[];
  readonly label: string;
  readonly onAddField: (field: string) => void;
};

/**
 * Addable drawer fields listed inline, for a drawer with no configured row.
 * Carries the add-field menu's row styling so the same list reads the same
 * whether it is inline or in the popover.
 */
export function FiltersDrawerAddFieldList({
  addableFieldConfigs,
  label,
  onAddField,
}: FiltersDrawerAddFieldListProps) {
  const labelId = useId();

  return (
    <div className="flex flex-col gap-2">
      <span className="text-tiga-text text-sm font-medium" id={labelId}>
        {label}
      </span>
      <MenuList
        aria-labelledby={labelId}
        className="overflow-hidden rounded-md border border-tiga-border-lighter bg-white p-0"
        data-testid="universal-filters-drawer-add-field-list"
      >
        {addableFieldConfigs.map((fieldConfig) => (
          <MenuItem
            key={fieldConfig.field}
            className="min-w-0 text-sm break-words whitespace-normal"
            onClick={() => {
              onAddField(fieldConfig.field);
            }}
          >
            {fieldConfig.label}
          </MenuItem>
        ))}
      </MenuList>
    </div>
  );
}
